import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

interface ComboInputProps {
  value: number;
  onChange: (val: number) => void;
  options: number[];
}

export function ComboInput({ value, onChange, options }: ComboInputProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative flex items-center gap-1" ref={containerRef}>
      <span className="text-xs text-[#6B6B6B] font-semibold">Max:</span>
      <div className="relative flex items-center">
        <input
          type="number"
          value={value || ''}
          onChange={(e) => onChange(Number(e.target.value) || 10)}
          onFocus={() => setIsOpen(true)}
          className="w-24 px-2 py-1 pr-6 rounded-md border border-[#E5E7EB] bg-white text-[#1E0036] text-sm focus:outline-none focus:border-violet-500"
        />
        <ChevronDown 
          className="w-4 h-4 absolute right-1.5 text-gray-400 cursor-pointer" 
          onClick={() => setIsOpen(!isOpen)} 
        />
        {isOpen && (
          <div className="absolute top-full right-0 mt-1 w-full bg-white border border-gray-200 shadow-lg rounded-md overflow-hidden z-50">
            {options.map((opt) => (
              <div
                key={opt}
                className="px-3 py-1.5 text-sm hover:bg-violet-50 cursor-pointer text-[#1E0036]"
                onClick={() => {
                  onChange(opt);
                  setIsOpen(false);
                }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
